module.exports = {
	"name": "keen-js",
	"version": "4.3.0",
	"license": "MIT",
	"main": "lib/index.js",
	"style": "style/index.css",
	"repository": {
		"type": "git",
		"url": "https://github.com/keen/keen-js.git"
	},
	"scripts": {
		"start": "gulp with-tests",
		"test": "gulp test:cli"
	},
	"bugs": "https://github.com/keen/keen-js/issues",
	"author": "Dustin Larimer <dustin@keen.io> (https://keen.io/)",
	"contributors": [
		"Dustin Larimer <dustin@keen.io> (https://github.com/dustinlarimer)",
		"Joanne Cheng <joanne@keen.io> (http://joannecheng.me)"
	],
	"dependencies": {
		"keen-analysis": "1.3.0",
		"keen-dataviz": "https://github.com/theopolisme/keen-dataviz.js.git#master",
		"keen-tracking": "1.4.0"
	},
	"devDependencies": {
		"browserify": "^8.0.3",
		"chai": "^1.10.0",
		"chai-spies": "^0.5.1",
		"del": "^1.1.0",
		"event-stream": "^3.1.7",
		"gulp": "^3.8.10",
		"gulp-awspublish": "0.0.23",
		"gulp-connect": "^2.2.0",
		"gulp-minify-css": "^1.2.4",
		"gulp-mocha": "^2.0.0",
		"gulp-mocha-phantomjs": "^0.11.0",
		"gulp-postcss": "^7.0.0",
		"gulp-remove-empty-lines": "0.0.2",
		"gulp-rename": "^1.2.0",
		"gulp-strip-comments": "^1.0.1",
		"gulp-uglify": "^1.5.4",
		"gulp-util": "^3.0.1",
		"karma": "^0.12.28",
		"karma-chrome-launcher": "^0.1.7",
		"karma-firefox-launcher": "^0.1.3",
		"karma-mocha": "^0.2.0",
		"karma-nyan-reporter": "0.0.50",
		"karma-requirejs": "^0.2.2",
		"karma-safari-launcher": "^0.1.1",
		"karma-sauce-launcher": "^0.2.10",
		"karma-sinon": "^1.0.4",
		"lodash.template": "^2.4.1",
		"mocha": "^2.4.5",
		"moment": "^2.8.4",
		"nock": "^0.51.0",
		"phantomjs": "^1.9.17",
		"postcss-cssnext": "^3.0.2",
		"postcss-import": "^10.0.0",
		"postcss-reporter": "^5.0.0",
		"pump": "^1.0.1",
		"requirejs": "^2.2.0",
		"sinon": "^1.17.3",
		"vinyl-transform": "^1.0.0"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/keen-js/package.json
// module id = 1860
// module chunks = 0